const removeTrailingSlash = (str?: string): string => (str ? str.replace(/\/+$/, '') : '');

export default removeTrailingSlash;
